import { RouteRecordRaw } from 'vue-router';
import { checkBrowserEnv } from '@/utils/utils';
import { getWechatAppidByDomain } from '@/api/basic';
export const reportRouters: RouteRecordRaw[] = [
  {
    path: '/reportDetailV1/:reportType',
    name: 'ReportDetailV1',
    component: () => import('@/pages/h5/Report/reportDetail/index.vue'),
    meta: {
      title: '报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/xgQuery',
    name: 'RecordReport',
    component: () => import('@/pages/h5/Report/recordReport/index.vue'),
    meta: {
      title: '信鸽流水报告查询页面',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/xgRegister',
    name: 'XgRegister',
    component: () => import('@/pages/h5/Report/recordReport/xgRegister.vue'),
    meta: {
      title: '信鸽银行流水查询',
      disabledNavBar: true,
    },
  },
  // {
  //   path: '/xgQuerycopy',
  //   name: 'xgQuerycopy',
  //   component: () => import('@/pages/h5/Report/recordReport/index2.vue'),
  //   meta: {
  //     title: '白鸽流水查询页面',
  //     checkAuth: true,
  //     disabledNavBar: true,
  //   },
  // },
  {
    path: '/recordSituation',
    name: 'RecordSituation',
    component: () => import('@/pages/h5/Report/recordReport/recordSituation.vue'),
    meta: {
      title: '信鸽查询结果页',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/recordXgDetail',
    name: 'RecordReportDetail',
    component: () => import('@/pages/h5/Report/recordReport/reportDetail.vue'),
    meta: {
      title: '信鸽流水报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/wechartXgDetail',
    name: 'WechartReportDetail',
    component: () => import('@/pages/h5/Report/recordReport/wechartReportDetail.vue'),
    meta: {
      title: '微信信鸽流水报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/aliXgDetail',
    name: 'AliReportDetail',
    component: () => import('@/pages/h5/Report/recordReport/aliReportDetail.vue'),
    meta: {
      title: '支付宝信鸽流水报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/bankXgDetail',
    name: 'BankReportDetail',
    component: () => import('@/pages/h5/Report/recordReport/bankReportDetail.vue'),
    meta: {
      title: '银行信鸽流水报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/alipayXgrecord',
    name: 'AlipayRecord',
    component: () => import('@/pages/h5/Report/recordReport/alipayrecord.vue'),
    meta: {
      title: '支付宝交易流水',
      checkAuth: true,
      disabledNavBar: true,
    },
  },

  {
    path: '/reportDetailV2/:reportType',
    name: 'ReportDetailV2',
    component: () => import('@/pages/h5/Report/reportDetailV2/index.vue'),
    meta: {
      title: '报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportDetailV3/:reportType',
    name: 'ReportDetailV3',
    component: () => import('@/pages/h5/Report/reportDetailV3/index.vue'),
    meta: {
      title: '报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportDetailV4/:reportType',
    name: 'ReportDetailV4',
    component: () => import('@/pages/h5/Report/reportDetailV4/index.vue'),
    meta: {
      title: '报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportDetailV5/:reportType',
    name: 'ReportDetailV5',
    component: () => import('@/pages/h5/Report/reportDetailV5/index.vue'),
    meta: {
      title: '报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportDetailFinance/:reportType',
    name: 'ReportDetailFinance',
    component: () => import('@/pages/h5/Report/reportDetailFinance/index.vue'),
    meta: {
      title: '融资企业报告',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportText/:reportType',
    name: 'ReportText',
    component: () => import('@/pages/h5/Report/reportText/index.vue'),
    meta: {
      title: '报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportLetterSieve/:reportType',
    name: 'ReportLetterSieve',
    component: () => import('@/pages/h5/Report/reportText/index.vue'),
    meta: {
      title: '报告详情',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportDetailNew/:reportType',
    name: 'ReportDetailNew',
    redirect: (to) => {
      const type = Number(to.params.reportType);
      const siteType = to.query.siteType || '';
      if (type === 21) {
        if (siteType === 'beehive-alipay') {
          return {
            name: 'AliReportDetail',
            params: to.params,
            query: to.query,
          };
        } else if (siteType === 'beehive-wechatpay') {
          return {
            name: 'WechartReportDetail',
            params: to.params,
            query: to.query,
          };
        } else {
          return {
            name: 'BankReportDetail',
            params: to.params,
            query: to.query,
          };
        }
      }
      return {
        name:
          type === 20
            ? 'ReportDetailV5'
            : type === 11
            ? 'ReportDetailFinance'
            : type === 6
            ? 'ReportDetailV4'
            : [1, 2, 3, 4, 5, 7, 9, 10].includes(type)
            ? 'ReportText'
            : 'ReportDetailV3',
        params: to.params,
        query: to.query,
      };
    },
  },

  //   {
  //   path: '/reportDetailNew/:reportType',
  //   name: 'ReportDetailNew',
  //   redirect: (to) => ({
  //     name:
  //       Number(to.params.reportType) === 6
  //         ? 'ReportDetailV4'
  //         : [1, 2, 3, 4, 5, 7, 9, 10].includes(Number(to.params.reportType))
  //         ? 'ReportDetailV1'
  //         : 'ReportDetailV3',
  //     // name: [1, 2, 3, 4, 5, 6, 7, 9, 10].includes(Number(to.params.reportType))
  //     //   ? 'ReportDetailV1'
  //     //   : 'ReportDetailV3',
  //     // name: 'ReportDetailV3',
  //     params: to.params,
  //     query: to.query,
  //   }),
  // },

  {
    path: '/reportQuery',
    name: 'OldReportInspection',
    redirect: (to) => {
      return {
        name: 'ReportInspection',
        params: to.params,
        query: to.query,
      };
    },
  },
  {
    path: '/bgQuery',
    name: 'ReportInspection',
    // component: () => import('@/pages/h5/Report/ReportInspection/ReportInspection.vue'),
    component: () => import('@/pages/h5/Report/ReportCheck/ReportCheck.vue'),
    meta: {
      title: '信息安全自查',
      checkBrowser: false,
      canCloseMask: true,
      // isCheckLinkId: true,
      disabledNavBar: true,
    },
    beforeEnter: async (to, from, next) => {
      if (!to.query.code && checkBrowserEnv('wechat')) {
        try {
          const res = await getWechatAppidByDomain({ domain: location.host });
          if (res?.appid) {
            const redirectUri = encodeURIComponent(location.href);
            location.replace(
              `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base#wechat_redirect`
            );
            return;
          }
        } catch (e) {
          console.error('微信授权获取appid失败', e);
        }
      }
      next();
    },
  },
  {
    path: '/agree',
    name: 'Agree',
    component: () => import('@/pages/h5/Report/ReportCheck/AgreePage.vue'),
    meta: {
      title: '平台服务声明',
      checkBrowser: false,
      canCloseMask: false,
      disabledNavBar: true,
    },
  },

  // 百行信筛
  {
    path: '/reportQuerySieve',
    name: 'ReportLetterSieve',

    component: () => import('@/pages/h5/Report/ReportCheck/ReportLetterSieve.vue'),
    meta: {
      title: '优享客',
      checkBrowser: false,
      canCloseMask: true,
      // isCheckLinkId: true,
      disabledNavBar: true,
    },
  },

  {
    path: '/reportXdQuery',
    name: 'ReportInspectionXd',
    // component: () => import('@/pages/h5/Report/ReportInspection/ReportInspectionXd.vue'),
    redirect: (to) => ({
      name: 'ReportInspection',
      query: Object.assign(
        {
          landingPage: 'reportXdQuery',
        },
        to.query
      ),
    }),
    meta: {
      title: '报告检查',
      checkBrowser: false,
      canCloseMask: true,
      isCheckLinkId: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportHyhQuery',
    name: 'ReportInspectionHyh',
    // component: () => import('@/pages/h5/Report/ReportInspection/ReportInspectionHyh.vue'),
    redirect: (to) => ({
      name: 'ReportInspection',
      query: Object.assign(
        {
          landingPage: 'reportHyhQuery',
        },
        to.query
      ),
    }),
    meta: {
      title: '报告检查',
      checkBrowser: false,
      canCloseMask: true,
      isCheckLinkId: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/reportQjhQuery',
    name: 'ReportInspectionQjh',
    component: () => import('@/pages/h5/Report/ReportInspection/ReportInspectionQjh.vue'),
    meta: {
      title: '报告检查',
      checkBrowser: false,
      canCloseMask: true,
      isCheckLinkId: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import('@/pages/h5/Payment/PaymentBox.vue'),
    meta: { title: '支付' },
    children: [
      {
        path: 'select',
        name: 'PaymentSelect',
        component: () => import('@/pages/h5/Payment/ChildPage/PaymentSelect.vue'),
        meta: { title: '支付方式', canCloseMask: true },
      },
      {
        path: 'result',
        name: 'PaymentResult',
        component: () => import('@/pages/h5/Payment/ChildPage/PaymentResult.vue'),
        meta: { title: '支付结果' },
      },
      {
        path: 'checkPayResult',
        name: 'CheckPayResult',
        component: () => import('@/pages/h5/Payment/ChildPage/CheckPayResult.vue'),
        meta: { title: '检查支付结果' },
      },
      {
        path: 'form',
        name: 'PaymentForm',
        component: () => import('@/pages/h5/Payment/ChildPage/AliPayForm.vue'),
        meta: { title: '支付' },
      },
    ],
  },
  {
    path: '/paymentV2',
    name: 'PaymentV2',
    component: () => import('@/pages/h5/PaymentV2/PaymentBox.vue'),
    meta: { title: '支付' },
    children: [
      {
        path: 'select',
        name: 'PaymentSelectV2',
        component: () => import('@/pages/h5/PaymentV2/ChildPage/PaymentSelect.vue'),
        meta: { title: '支付方式', canCloseMask: true },
      },
      {
        path: 'jsapiselect',
        name: 'JsApiMentResultV2',
        component: () => import('@/pages/h5/PaymentV2/ChildPage/JsApiMentResult.vue'),
        meta: { title: '支付信息', canCloseMask: true },
      },
      {
        path: 'result',
        name: 'PaymentResultV2',
        component: () => import('@/pages/h5/PaymentV2/ChildPage/PaymentResult.vue'),
        meta: { title: '支付结果' },
      },
      {
        path: 'checkPayResult',
        name: 'CheckPayResultV2',
        component: () => import('@/pages/h5/PaymentV2/ChildPage/CheckPayResult.vue'),
        meta: { title: '检查支付结果' },
      },
      {
        path: 'form',
        name: 'PaymentFormV2',
        component: () => import('@/pages/h5/PaymentV2/ChildPage/AliPayForm.vue'),
        meta: { title: '支付' },
      },
    ],
  },
  {
    path: '/paymentV3',
    name: 'PaymentV3',
    component: () => import('@/pages/h5/PaymentV3/PaymentBox.vue'),
    meta: { title: '支付' },
    children: [
      {
        path: 'select',
        name: 'PaymentSelectV3',
        component: () => import('@/pages/h5/PaymentV3/ChildPage/PaymentSelect.vue'),
        meta: { title: '支付方式', canCloseMask: true, disabledNavBar: true },
      },
      {
        path: 'result',
        name: 'PaymentResultV3',
        component: () => import('@/pages/h5/PaymentV3/ChildPage/PaymentResult.vue'),
        meta: { title: '支付结果' },
      },
      {
        path: 'checkPayResult',
        name: 'CheckPayResultV3',
        component: () => import('@/pages/h5/PaymentV3/ChildPage/CheckPayResult.vue'),
        meta: { title: '检查支付结果' },
      },
      {
        path: 'form',
        name: 'PaymentFormV3',
        component: () => import('@/pages/h5/PaymentV3/ChildPage/AliPayForm.vue'),
        meta: { title: '支付' },
      },
    ],
  },
  {
    path: '/myReportListV1',
    name: 'myReportListV1',
    component: () => import('@/pages/h5/Report/MyReport.vue'),
    meta: { title: '我的报告' },
  },
  {
    path: '/myReportList',
    name: 'myReportList',
    redirect: (to) => ({
      name: 'myReportListV1',
      params: to.params,
      query: to.query,
    }),
  },
  // {
  //   path: '/myReportList',
  //   name: 'myReportList',
  //   component: () => import('@/pages/h5/Report/MyReport.vue'),
  //   meta: { title: '我的报告' },
  // },
  {
    path: '/channel-check',
    name: 'ChannelCheck',
    component: () => import('@/pages/h5/Report/ChannelCheck/index.vue'),
    meta: { title: '渠道查询', disabledNavBar: true },
  },
  {
    path: '/channelCheckList',
    name: 'ChannelCheckList',
    component: () => import('@/pages/h5/Report/ChannelCheck/ChildPage/ReportList.vue'),
    meta: { title: '查询记录' },
  },
  {
    path: '/custom-report',
    name: 'CustomReport',
    component: () => import('@/pages/h5/Report/CustomReport/index.vue'),
    meta: { title: '定制报告' },
  },
  {
    path: '/my-complaint',
    name: 'myComplaint',
    component: () => import('@/pages/h5/Mine/MyComplaint/index.vue'),
    meta: { title: '我的投诉' },
  },
  {
    path: '/securityCheck',
    name: 'SecurityCheck',
    component: () => import('@/pages/h5/Report/ReportTransfer/index.vue'),
    meta: {
      title: '检测',
      checkBrowser: false,
      canCloseMask: true,
      // isCheckLinkId: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/shareLanding',
    name: 'ShareLanding',
    component: () => import('@/pages/h5/Report/ShareLanding/index.vue'),
    meta: {
      title: '公开信息查询',
      checkBrowser: false,
      canCloseMask: true,
      disabledNavBar: true,
    },
  },
  {
    path: '/letterSieve',
    name: 'LetterSieve',
    component: () => import('@/pages/h5/Report/LetterSieve/index.vue'),
    meta: {
      title: '百行信筛',
      checkBrowser: false,
      canCloseMask: true,
      disabledNavBar: true,
    },
  },
];
